import { BrowserRouter as Router, Routes, Route } from 'react-router';
import CrisprPage from './pages/CrisprPage.js';
import React from 'react';
import ArticleNavPage from './components/Cripsr/ArticleNavPage.js';
import HomePage from './pages/HomePage.js';
import MoonParallax from './pages/MoonParallax.js';
import ApolloPage from './pages/ApolloPage.js';
import PhonesPage from './pages/PhonesPage.js';
import FriendOrFoePage from './pages/FriendOrFoePage.js';
import GutCheckPage from './pages/GutCheckPage.js';
import PrivacyBurdenPage from './pages/PrivacyBurdenPage.js';
import RechargingPage from './pages/RechargingPage.js';
import StoneAndSilicon from './pages/StoneAndSiliconPage.js';
import DogsPage from './pages/DogsPage.js';
import DogsTeachUsPage from './pages/DogsTeachUsPage.js';
import DogsWeCanDo from './pages/DogsWeCanDoPage.js';
import ScrollToTop from './components/ScrollToTop.js';

function App() {
  return (
    <Router>
      <ScrollToTop behavior="auto" /> {/* or 'smooth' */}
      <Routes>
        <Route path="/crispr" element={<CrisprPage />} />
        <Route path="/phones" element={<PhonesPage />} />
        <Route path="/dogs" element={<DogsPage />} />
        <Route path="/dogs/teach" element={<DogsTeachUsPage />} />
        <Route path="/dogs/wecando" element={<DogsWeCanDo />} />
        <Route path="/phones/friendorfoe" element={<FriendOrFoePage />} />
        <Route path="/phones/gutcheck" element={<GutCheckPage />} />
        <Route path="/phones/stoneandsilicon" element={<StoneAndSilicon />} />
        <Route path="/phones/privacyburden" element={<PrivacyBurdenPage />} />
        <Route path="/phones/recharging" element={<RechargingPage />} />
        <Route path="/arc" element={<ArticleNavPage />} />
        <Route path='/moon' element={<MoonParallax />} />
        <Route path='/apollo' element={<ApolloPage />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
